import {GUKEO_API_URL1} from "./protocol";

// 녹음 시작 후 중지까지 timeout 시간 (ms).
// 녹음 버튼을 누른 후 이 시간까지 종료하지 않으면 자동으로 종료된다.
export const RECORD_STOP_TIMEOUT = 4000;

export const SAMPLE_RATE = 16000;

export const DEFAULT_VOICE_AVG = 0.350;

export const INTONATION_STEP = 0.090;

// export const MODEL_URL = 'https://tfhub.dev/google/tfjs-model/spice/2/default/1';

// NOTE: DRF 개발서버에서 media에 올리면 문제가 없는데, static올릴 때에는 CORS 오류 뜸. 원인은 모르겠음.
// export const MODEL_URL = GUKEO_API_URL1 + '/static/spice/spice_1_default_1';
export const MODEL_URL = GUKEO_API_URL1 + '/static/spice/tfjs-model_spice_2_default_1';

export const SPICE_UNIT = 512; // SPICE에서 처리하는 최소 버퍼 단위
export const SPICE_PREDICT_UNIT = 20; // 한번에 SPICE에 넣는 버퍼의 크기를 512 x n 으로 설정함.
export const SPICE_CHUNK_SIZE = SPICE_UNIT * SPICE_PREDICT_UNIT;
export const SPICE_PREDICT_OUT_LEN = SPICE_PREDICT_UNIT + 1; // 한번에 받는 SPICE 결과 배열의 크기.


export enum WORD_ITYPE {
  NONE,   // 해당 없음
  ITYPE1, // 상
  ITYPE2, // 중
  ITYPE3, // 상중
  ITYPE4, // 하
  ITYPE5, // 상하
  ITYPE6, // 중하
  ITYPE7, // 상중하
};


/******************************************************************************
 * wav-graph-config
 *****************************************************************************/

export type RECORDER_CONFIG = {
  voiceAvg: number;       // 목소리 중간 값 (0~1 사이의 값)
  maxDiff?: number;       // 파형 데이터의 간격 0.0 ~ 1.0
  lineDiff?: number;      //
};

export const LIST_RECORDER_CONFIG: Array<RECORDER_CONFIG> = [
  {
    // RECORDER_TYPE:RECORDER_A
    voiceAvg: 0.450,
  },
  {
    // RECORDER_TYPE:RECORDER_B
    voiceAvg: 0.350,
  },
  {
    // RECORDER_TYPE:RECORDER_C
    // 디버그용으로 전체 범위가 다 보이도록 수정.
    voiceAvg: 0.500,
    maxDiff: 1.0,
  },
];
